module.exports = __webpack_public_path__ + "static/img/wulumuqipu1.86cab25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wulumuqipu1.png
// module id = 5VMl
// module chunks = 1